import { render, staticRenderFns } from "./EmployeesForm.vue?vue&type=template&id=20e8e984&"
import script from "./EmployeesForm.vue?vue&type=script&lang=js&"
export * from "./EmployeesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports